const files = require.context(__dirname, false, /\.png$/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./project/client/src/site__ale001/components/blocks/profile-banner/images/index.js